export default __webpack_public_path__ + "static/media/campaign-2-en.80b40950.svg";